t = require('app/scripts/views/internal/teacup-with-helpers')('org_member_activity')

memberOfBoardsMessage =  (
  hasString = 'name-is-member-of-boards'
  variables = {
    name: t.mustacheVar('fullName')
  }
) ->
  t.p '.quiet', ->
    t.format hasString, variables

module.exports = ->
  t.div '.org-member-activity-popover', ->
    t.mustacheBlock 'isPremium', ->
      t.mustacheBlock 'lastActive', ->
        memberOfBoardsMessage(
          'name-is-member-of-boards-and-has-activity',
          {
            name: t.mustacheVar('fullName')
            fullName: t.mustacheVar('fullName'),
            lastActive: t.mustacheVar('lastActive')
          }
        )

      t.mustacheBlockInverted 'lastActive', ->
        memberOfBoardsMessage()

    t.mustacheBlockInverted 'isPremium', ->
      memberOfBoardsMessage()

    t.ul '.pop-over-list.js-member-boards'

    t.mustacheBlock 'canRemoveFromAllTeamBoards', ->
      t.p '.can-remove-all', ->
        t.b '.button-link.remove-all-button.js-remove-guest-from-team-boards',
        {
          'data-teamboardcount': t.mustacheVar('teamBoardCount')
        }, ->
          t.format 'remove-from-all-team-boards'

    t.mustacheBlock 'orgCardsUrl', ->
      t.hr()

      t.ul '.pop-over-list', ->
        t.li ->
          t.a '.js-view-member-org-cards', {
            href: t.mustacheVar('orgCardsUrl')
          }, ->
            t.format 'view-members-org-cards'
